<template>
  <div>
    <el-button class="button" type="primary" @click="add">新增</el-button>
    <el-button
      class="button"
      style="margin-right: 10px;"
      type="primary"
      @click="saveSortData()"
      >保存排序</el-button
    >
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <!-- <el-tab-pane label="库别管理" name="first">
        <el-table
          :data="kuData"
          border
          class="table"
          header-cell-class-name="table-header"
          v-loading="loading"
        >
          <el-table-column
            prop="title"
            label="标题"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column label="移动" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="moveUp(scope.row, scope.$index, 1)"
                :disabled="scope.$index == 0"
                >上</el-button
              >
              <el-button
                type="text"
                @click="moveDown(scope.row, scope.$index, 1)"
                :disabled="kuData.length - 1 == scope.$index"
                >下</el-button
              >
              <el-button
                type="text"
                @click="moveTop(scope.row, scope.$index, 1)"
                :disabled="scope.$index == 0"
                >置顶</el-button
              >
              <el-button
                type="text"
                @click="moveBottom(scope.row, scope.$index, 1)"
                :disabled="kuData.length - 1 == scope.$index"
                >置底</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" width="100">
            <template slot-scope="scope">
              {{ formatDate(scope.row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane> -->
      <!-- <el-tab-pane label="分类管理" name="first">
        <el-table
          :data="fenData"
          style="width: 100%; margin-bottom: 20px"
          row-key="id"
          border
          default-expand-all
        >
          <el-table-column prop="title" align="center" label="名称" width="150">
          </el-table-column>
          <el-table-column label="移动" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="text" @click="moveUp(scope.row, scope.$index, 2)"
                >上</el-button
              >
              <el-button
                type="text"
                @click="moveDown(scope.row, scope.$index, 2)"
                >下</el-button
              >
              <el-button
                type="text"
                @click="moveTop(scope.row, scope.$index, 2)"
                >置顶</el-button
              >
              <el-button
                type="text"
                @click="moveBottom(scope.row, scope.$index, 2)"
                >置底</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" width="100">
            <template slot-scope="scope">
              {{ formatDate(scope.row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row, 1)"
                >删除</el-button
              >
              <el-button
                v-if="scope.row.children"
                type="text"
                @click="addSon(scope.row)"
                >添加子分类</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane> -->
      <el-tab-pane label="朝代管理" name="first">
        <el-table
          :data="chaoData"
          border
          class="table"
          row-key="id"
          ref="windowMultipleTable"
          header-cell-class-name="table-header"
          v-loading="loading"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="标题"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row, 2)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="120px">
        <el-form-item label="朝代名称：" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/zkApiConfig";
import Sortable from "sortablejs";
export default {
  name: "Doctorlist",
  data() {
    return {
      is_add: true,
      editVisible: false,
      activeName: "first",
      loading: false,
      father_class: [{ label: "无", value: 0 }],
      chaoData: [],
      form: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 列表
    getData() {
      http.get("/admin/admin_books/dynasties").then((res) => {
        if (res.data.status_code == 200) {
          this.chaoData = res.data.data;
          this.$nextTick(() => {
            this.initSortTable();
          });
          console.log(res, "res");
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    saveSortData() {
      let chao_ids = [];
      for (let i = 0; i < this.chaoData.length; i++) {
        chao_ids.push(this.chaoData[i].id);
      }
      // let params = {
      //   doctor_ids: this.doctor_ids.toString(),
      // };
      // http
      //   .put("/admin/studios/" + this.doc_studio_id + "/doctors/order", params)
      //   .then((res) => {
      //     if (res.data.status_code == 200) {
      //       this.$message.success("保存成功");
      //       this.studioDoctorlist(this.doc_studio_id);
      //     } else {
      //       this.$message.error(res.data.msg);
      //     }
      //   });
      // console.log(chao_ids.toString(), "str");
    },
    // 拖拽
    initSortTable() {
      // 获取 el-table
      const tableTag = this.$refs["windowMultipleTable"].$el;
      // 获取 tbody 节点
      const elTbody = tableTag.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      // 拖拽排序
      this.sortable = Sortable.create(elTbody, {
        onEnd: (evt) => {
          const tempIndex = this.chaoData.splice(evt.oldIndex, 1)[0];
          this.chaoData.splice(evt.newIndex, 0, tempIndex);
          console.log(this.chaoData, "chaoData");
        },
      });
    },
    // 新增
    add() {
      this.is_add = true;
      this.form = {};
      this.editVisible = true;
    },
    // 提交
    saveEdit() {
      if (this.is_add == true) {
        let params = {
          name: this.form.name,
          remark: this.form.remark,
        };
        http.post("/admin/admin_books/dynasties/add", params).then((res) => {
          if (res.data.status_code == 200) {
            this.editVisible = false;
            this.getData();
            this.$message.success("新增成功");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        let params = {
          name: this.form.name,
          remark: this.form.remark,
        };
        http
          .put("/admin/admin_books/dynasties/" + this.form.id, params)
          .then((res) => {
            if (res.data.status_code == 200) {
              this.editVisible = false;
              this.getData();
              this.$message.success("修改成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    // 编辑
    handleEdit(row) {
      this.is_add = false;
      this.editVisible = true;
      this.form = {
        name: row.name,
        remark: row.remark,
        id: row.id,
      };
      console.log(this.form, "form");
    },
    // 删除
    handleDelete(row) {
      let that = this;
      // 二次确认删除
      //
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/admin_books/dynasties/" + row.id).then((res) => {
            if (res.data.status_code == 200) {
              that.getData();
              that.$message.success("删除成功");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 选项卡
    handleClick() {
      // if (tab.index == 0) {
      //   console.log(1);
      // } else if (tab.index == 1) {
      //   http.get("/admin/admin_books/dynasties").then((res) => {
      //     if (res.data.status_code == 200) {
      //       this.chaoData = res.data.data;
      //       this.$nextTick(() => {
      //         this.initSortTable();
      //       });
      //       console.log(res, "res");
      //     } else {
      //       this.$message.success(res.data.msg);
      //     }
      //   });
      // }
    },
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  float: right;
}
/deep/.el-tabs__header {
  width: 903px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
